<template>
    <rkm-overlay>
        <rkm-layout-body title="Exames agendados/realizados por paciente">
            <template v-slot:actions>
                <rkm-button
                    @click.stop="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.imprimirHistorico()"
                    color="primary"
                >
                    Imprimir histórico
                </rkm-button>
            </template>
            <rkm-layout-content v-if="loaded">
                <Form
                    ref="Form"
                    :data="{ initials, form, model, additionals }"
                    :id="id"
                    @handleExit="handleExit"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import Form from '@/components/exame-imagem/exame-agendado-realizado/Form'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            exameAgendadoRealizado: this.getConectaSusRepository('exameImagem.exameAgendadoRealizado'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.exameAgendadoRealizado.list()
                .then(({ data }) => {

                    data.model.periodo.start = this.getDateObject(data.model.periodo.start)
                    data.model.periodo.end = this.getDateObject(data.model.periodo.end)

                    this.initials.model = Object.freeze(this.clone(data.model))

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {

            this.redirectToList()
        },
        redirectToList() {

            this.$router.push({ name: 'exame-imagem-exame-agendado-realizado-index' })
        }
    },
    mixins: [repository, error, object, data],
    props: {
        id: { type: Number, default: null }
    },
}
</script>